/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_quantity = /** @type {(inputs: {}) => string} */ () => {
	return `Množství`
};

const da_quantity = /** @type {(inputs: {}) => string} */ () => {
	return `Antal`
};

const de_quantity = /** @type {(inputs: {}) => string} */ () => {
	return `Menge`
};

const en_quantity = /** @type {(inputs: {}) => string} */ () => {
	return `Quantity`
};

const es_quantity = /** @type {(inputs: {}) => string} */ () => {
	return `Cantidad`
};

const fr_quantity = /** @type {(inputs: {}) => string} */ () => {
	return `Quantité`
};

const hu_quantity = /** @type {(inputs: {}) => string} */ () => {
	return `Mennyiség`
};

const it_quantity = /** @type {(inputs: {}) => string} */ () => {
	return `Quantità`
};

const nl_quantity = /** @type {(inputs: {}) => string} */ () => {
	return `Aantal`
};

const pl_quantity = /** @type {(inputs: {}) => string} */ () => {
	return `Ilość`
};

const pt_quantity = /** @type {(inputs: {}) => string} */ () => {
	return `Quantidade`
};

const sv_quantity = /** @type {(inputs: {}) => string} */ () => {
	return `Antal`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const quantity = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.quantity(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("quantity", locale)
	if (locale === "cs") return cs_quantity(inputs)
	if (locale === "da") return da_quantity(inputs)
	if (locale === "de") return de_quantity(inputs)
	if (locale === "en") return en_quantity(inputs)
	if (locale === "es") return es_quantity(inputs)
	if (locale === "fr") return fr_quantity(inputs)
	if (locale === "hu") return hu_quantity(inputs)
	if (locale === "it") return it_quantity(inputs)
	if (locale === "nl") return nl_quantity(inputs)
	if (locale === "pl") return pl_quantity(inputs)
	if (locale === "pt") return pt_quantity(inputs)
	return sv_quantity(inputs)
};